import type { Dayjs } from "dayjs";

import { swSettings } from "app/common/services/swSettings";

interface IAlertsConfig {
    dailyStartDate?: Dayjs;
    dailyEndDate?: Dayjs;
}

export const getAlertsAvailableDates = () => {
    const isAlertsAllowed: boolean = swSettings?.components?.Alerts?.isAllowed;
    const componentConfig: IAlertsConfig = swSettings?.components?.Alerts;

    if (!isAlertsAllowed || !componentConfig?.dailyStartDate || !componentConfig?.dailyEndDate) {
        return {};
    }

    return {
        minDate: componentConfig.dailyStartDate,
        maxDate: componentConfig.dailyEndDate,
    };
};
